import { SecondaryButton } from 'components/v2/buttons';
import { Dialog } from 'primereact/dialog';
import { HeaderDialog } from 'styles/Styles.styled';
import { Description, DialogContainer } from 'components/v2/confirm-dialog/styled';
import { InfoIcon } from 'components/v2/icons';

type TProps = {
  isOpened: boolean;
  onHide: any;
};

const UpdateCompanyInvoiceCurrencyDialog = ({ isOpened, onHide }: TProps) => {
  const content = (
    <DialogContainer>
      <InfoIcon />
      <HeaderDialog>New payment option available!</HeaderDialog>
      <Description>
        Dear EPD Owner, <br />
        you can now choose to pay your invoices in <b>USD</b>.<br /> To update your preferred currency, visit the{' '}
        <b>Invoice Info</b> tab in your dashboard.
      </Description>
    </DialogContainer>
  );

  const footerContent = (
    <SecondaryButton
      label='Close'
      onClick={() => onHide(true)}
    />
  );

  return (
    <Dialog
      children={content}
      closable={true}
      visible={isOpened}
      footer={footerContent}
      onHide={() => onHide(true)}
      headerClassName='m-0 p-0'
      className='custom-dialog'
    />
  );
};

export default UpdateCompanyInvoiceCurrencyDialog;
